// extracted by mini-css-extract-plugin
module.exports = {"price":"tC-z","onSale":"uC-z"};